import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './services/auth-service.service';
@Injectable({
  providedIn: 'root',
})
export class RoleBasedGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const userRoles = this.authService.getUserRole();
    const requiredRoles: string[] = route.data['roles'];





    if (requiredRoles && userRoles.some((role) => requiredRoles.includes(role))) {
      return true;
    }

    if (userRoles.includes(Roles.EXTERNAL)) {
      await this.router.navigate(['/external-contact']);
      return false;
    }


    await this.router.navigate(['/unauthorized']);
    return false;
  }

}

export const Roles = {
  INTERNAL: "1",
  EXTERNAL: "2",
};
